




import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";

@Component
class DefaultLayoutAppBar extends Vue {
  @State(state => state.app.appbar) appbar;

  get appbarMeta() {
    const background = this.$vuetify.theme.currentTheme.background;

    return {
      color: this.appbar.color ? this.appbar.color : background,
      show: this.appbar.show,
      back: this.appbar.back,
      title: this.appbar.title,
      dark: this.appbar.dark,
      align: this.appbar.align || "center",
      style: this.appbar.color === "transparent" ? this.appbar.style : undefined
    };
  }

  handleBack() {
    if (this.$route.query.back) {
      const back = decodeURIComponent(this.$route.query.back as string);
      window.location.href = back;
    } else if (window.history.length <= 1) {
      this.$helper.toFusionPath(this, "wallet", { name: "index" });
    } else {
      this.$router.back();
    }
  }
}
export default DefaultLayoutAppBar;
